// import node module libraries
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

// import sub components
import Loader from "components/elements/miscellaneous/Loader";
import { DashboardContext } from "context/Context";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import HeaderDefault from "./HeaderDefault";
import NavbarVertical from "./NavbarVertical";

const DashboardIndex = (props) => {
  const { children, className, overflowHidden } = props;
  const [showMenu, setShowMenu] = useState(true);
  const auth = getAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const db = getFirestore();

  const [user, setUser] = useState({});
  const [company, setCompany] = useState({});
  const [isCompanyActive, setIsCompanyActive] = useState(null);
  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const value = {
    user,
    setUser,
    company,
    setCompany,
  };

  const [loading, setLoading] = useState(true);
  const ToggleMenu = () => {
    return setShowMenu(!showMenu);
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        // ...
        // const { emailVerified } = user;

          const docRef = doc(db, "users", uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUser(docSnap.data());
            if (!docSnap.data().registrationComplete) {
              navigate("/sign-up/company");
            } else {
              const companyRef = doc(db, "companies", docSnap.data().companyId);
              const companySnap = await getDoc(companyRef);
              if (companySnap.exists()) {
                const companyData = companySnap.data();
                const status =
                  typeof companyData.status === "string" ? companyData.status.toLowerCase() : "";
                const companyIsActive = status === "active";
                setCompany(companyData);
                setIsCompanyActive(companyIsActive);
                setShowInactiveModal(!companyIsActive);
                setLoading(false);
              } else {
                setIsCompanyActive(false);
                setShowInactiveModal(true);
                setLoading(false);
              }
            }
          } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
            navigate("/landing");
          }
      
      } else {
        // User is signed out
        navigate("/landing");
      }
    });
    return () => unsubscribe();
  }, []);
  const SubscriptionInactiveModal = () => {
    return (
      <Modal show={showInactiveModal} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Subscripción inactiva</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          La subscripción de tu empresa no está activa. Realiza el pago para recuperar el acceso al
          panel.
        </Modal.Body>
        <Modal.Footer>
          <Link to="https://wa.me/528114706347" target="__blank">
            <Button variant="primary">Contactáctanos por whatsapp</Button>
          </Link>
        </Modal.Footer>
      </Modal>
    );
  };
  const isBlocked = isCompanyActive === false;
  const companyPlan = typeof company?.plan === "number" ? company.plan : 0;
  const isSalesForecastRestricted =
    companyPlan < 2 && location.pathname === "/dashboard/sales/forecasts";
  const upsellPath = "/dashboard/upsell/ventas";

  useEffect(() => {
    if (loading || isBlocked) return;
    if (isSalesForecastRestricted && location.pathname !== upsellPath) {
      navigate(upsellPath, { replace: true, state: { from: location.pathname } });
    }
  }, [isSalesForecastRestricted, isBlocked, loading, location.pathname, navigate]);
  return (
    <DashboardContext.Provider value={value}>
      <div
        id="db-wrapper"
        className={`${overflowHidden ? "chat-layout" : ""} ${showMenu ? "" : "toggled"}`}
      >
        <div className="navbar-vertical navbar">
          <NavbarVertical showMenu={showMenu} onClick={(value) => setShowMenu(value)} />
        </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <SubscriptionInactiveModal />
            <section id="page-content">
              <div className="header">
                <HeaderDefault
                  data={{
                    showMenu: showMenu,
                    SidebarToggleMenu: ToggleMenu,
                  }}
                />
              </div>

              <div className={`container-fluid ${className ? className : "p-4"}`}>
                {isBlocked ? (
                  <div className="d-flex flex-column align-items-center justify-content-center py-6">
                    <h3 className="mb-2 text-center">Acceso limitado</h3>
                    <p className="mb-0 text-muted text-center">
                      Activa tu suscripcion para navegar por el dashboard.
                    </p>
                  </div>
                ) : (
                  <>
                    {children}
                    <Outlet />
                  </>
                )}
              </div>
            </section>
          </>
        )}
      </div>
    </DashboardContext.Provider>
  );
};
export default DashboardIndex;
